import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useHasWIVOrEIVAccess } from '@frontend/insurance-verification';
import { useAppScopeStore } from '@frontend/scope';

// TODO: MOVE TO INSURANCE TEAM
export const useShouldShowCalendarInsuranceCount = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { hasInsuranceVerificationAccess } = useHasWIVOrEIVAccess();

  const hasAccessToInsuranceVerification = selectedLocationIds.some((locationId) =>
    hasSchemaACL(locationId, [Permission.INSURANCE_VERIFICATION_READ, Permission.INSURANCE_VERIFICATION_WRITE])
  );

  return hasInsuranceVerificationAccess && hasAccessToInsuranceVerification;
};
